<script>
export default {
  props: {
    value: String,
    autoFocus: Boolean,
  },

  data: () => ({
    batchSummaries: [],
  }),

  computed: {
    selectedBatchAgeInWeeks() { return this.value && this.batchSummaryByName(this.value) ? this.batchSummaryByName(this.value).age_in_weeks : undefined },

    selectOptions() {
      return [{ value: '', text: 'Select batch name...' }]
        .concat(this.batchSummaries.map(x => ({ value: x.name, text: x.name })));
    },
  },

  watch: {
    batchSummaries(to, from) {
      if (this.autoFocus && to) {
        this.$nextTick(() => { this.$refs.selectElem.$el.focus() });
      }
    },
  },

  methods: {
    batchSummaryByName(name) { return this.batchSummaries.find(x => String(x.name) === String(name)) },
  },
}
</script>

<template>
  <api-loader
    method="get"
    url="v1/layeradmin/batches"
    @loaded="batchSummaries=$event"
    :show-busy="false"
    :show-error="false">

    <div class="position-relative" slot-scope="{busy, error}">
      <b-form-group label="Batch Name" :label-for="`select-${_uid}`" :class="{'mb-0':selectedBatchAgeInWeeks}">
        <b-form-select
          :value="value"
          @input="$emit('input', $event)"
          @change="$emit('change', $event)"
          :id="`select-${_uid}`"
          :options="selectOptions"
          v-bind="$attrs"
          :disabled="busy"
          plain
          ref="selectElem">
        </b-form-select>
      </b-form-group>

      <div v-if="selectedBatchAgeInWeeks" class="mb-2 text-right"> <small class="text-muted">{{selectedBatchAgeInWeeks}} weeks</small> </div>

      <div v-if="busy||error" class="position-absolute" style="bottom:8px; right:20px;">
        <i v-if="busy" class="fa fa-spinner fa-spin"></i>
        <span v-else-if="error" class="text-danger">{{error}}</span>
      </div>
    </div>
  </api-loader>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AdminBatchChooser.vue